import React, { useEffect, useRef } from "react";
import * as S from "./VideoModal.styles";
import { useLockBodyScroll } from "react-use";
import { VideoModalProps } from "./VideoModal.types";
import clsx from "clsx";

export const VideoModal = ({
  src,
  poster,
  isOpen,
  onClose,
  className,
  showCloseButton,
  motif,
}: VideoModalProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useLockBodyScroll(isOpen);

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    try {
      if (isOpen) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    } catch {
      // Do nothing
    }
  }, [isOpen]);

  // #############################################################################
  // Render
  // #############################################################################
  return (
    <S.Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={clsx("videoPlayerModal", className)}
      contentClassName={S.CONTENT_CLASSNAME}
      size="large"
    >
      <S.VideoPlayer
        isOpen
        src={src}
        ref={videoRef}
        onClose={onClose}
        poster={poster}
        showCloseButton={showCloseButton}
        motif={motif}
      />
    </S.Modal>
  );
};
